import(/* webpackMode: "eager" */ "/builds/entertainment-offical/ent-web-cli/src/app/activity/outside-download/page.jsx");
